import {Text, Overlay} from 'src/v2/components/common';
import {WalletIcon} from 'src/v2/components/wallet/WalletIcon';
import {useSelector} from 'src/v2/state/store';
import {WalletRegistry} from 'src/v2/util/WalletRegistry';
import {message, useIntl} from '@sail/intl';

const messages = {
  confirm: message<{
    businessName: React.ReactNode;
  }>({
    id: 'crypto.payins.v2.payment_confirmation_pending.confirm_transaction_setup_future_usage',

    description:
      'Prompt to tell the user to allow withdrawing funds for the current and future transactions in the crypto wallet',

    defaultMessage:
      'To complete this purchase, allow {businessName} to withdraw funds from your wallet.',
  }),
};

export const FutureUsageConfirmationPendingOverlay = () => {
  const intl = useIntl();
  const activeWallet = useSelector(
    (state) => state.walletConnection.activeWallet,
  );
  const businessName = useSelector(
    (state) => state.merchantBranding.businessName,
  );

  if (!activeWallet) {
    throw new Error(
      'activeWallet is required in PaymentConfirmationPendingOverlay',
    );
  }

  const walletOption = WalletRegistry.getWalletOption({
    provider: activeWallet.type,
    key: activeWallet.key,
  });

  if (!walletOption) {
    throw new Error(
      'Wallet option not found in PaymentConfirmationPendingOverlay',
    );
  }

  return (
    <Overlay name="subscription-confirmation-pending">
      <WalletIcon walletOption={walletOption} />
      <Text type="heading">
        {intl.formatMessage(messages.confirm, {businessName})}
      </Text>
    </Overlay>
  );
};
